import { c as _c } from "react/compiler-runtime";
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useHits } from 'react-instantsearch';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import useStaticProductCardData from 'hooks/useStaticProductCardData';
import { useAtom } from 'jotai';
import handleProductClick from '../../algolia-insights-helpers/handleInsightsProductClick';
import lastInsightsClickAtom from '../../advanced-search/atoms/lastInsightsClickAtom';

// TODO: CON-7887: (Codemod generated): ensure your usage correctly maps the props from the connector to the hook
function connectHits(Component) {
  const Hits = props => {
    const $ = _c(3);
    const data = useHits(props);
    let t0;
    if ($[0] !== data || $[1] !== props) {
      t0 = <Component {...props} {...data} />;
      $[0] = data;
      $[1] = props;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  };
  return Hits;
}

/**
 * Product grid component for Old Consumer App (React)
 * Makes one GraphQL call for all products (like mobile search)
 */
const ProductGridOldConsumerApp = connectHits(({
  hits
}) => {
  const [, setLastInsightsClick] = useAtom(lastInsightsClickAtom);

  // Extract product IDs from Algolia hits
  const productIds = hits.map(hit => parseInt(hit.product_id || hit.objectID, 10));

  // Make one GraphQL call for all products (same as mobile)
  const {
    products,
    loading
  } = useStaticProductCardData({
    productIds,
    limit: -1 // Same as mobile
  });
  if (!hits || hits.length === 0) {
    return <div className="text-center py-8 text-gray-500">No products found</div>;
  }

  // Create a map of product ID to product data for quick lookup
  const productMap = products?.reduce((acc, product) => {
    acc[product.id] = product;
    return acc;
  }, {}) || {};
  if (loading) {
    return <ProductCardGridUI columnsOnDesktop="3" columnsOnMobile="2" limitWidth={false}>
        {hits.map(hit => <div key={hit.objectID} className="bg-white p-4 rounded-lg shadow-sm">
            <div className="h-48 bg-gray-200 rounded mb-4 flex items-center justify-center">
              <div className="text-gray-500">Loading...</div>
            </div>
            <div className="h-4 bg-gray-200 rounded mb-2" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
          </div>)}
      </ProductCardGridUI>;
  }
  return <ProductCardGridUI columnsOnDesktop="3" columnsOnMobile="2" limitWidth={false}>
      {hits.map((hit, index) => {
      const productId = parseInt(hit.product_id || hit.objectID, 10);
      const product = {
        ...productMap[productId],
        name: hit?.name ?? ''
      };
      if (!product) {
        // Fallback if product not found in GraphQL response
        return <div key={hit.objectID} className="bg-white p-4 rounded-lg shadow-sm">
              <div className="h-48 bg-gray-200 rounded mb-4" />
              <div className="h-4 bg-gray-200 rounded mb-2" />
              <div className="h-4 bg-gray-200 rounded w-2/3" />
            </div>;
      }
      return <ProductCardStatic key={hit.objectID} {...product} position={index + 1} layout="minimal" analyticsComponentName="search-product-card" onClick={() => {
        handleProductClick({
          objectID: hit?.objectID,
          position: hit?.__position,
          queryID: hit?.__queryID
        });
        setLastInsightsClick(hit);
      }} />;
    })}
    </ProductCardGridUI>;
});
export default ProductGridOldConsumerApp;